<nz-form-control *ngIf="recordProperty != null && !isMultiple">
  <img
    style="width: 100%;height: auto;object-fit: cover;"
    *ngIf="
      recordProperty.ValueAsObject != null && recordProperty.ValueAsObject != ''
    "
    [src]="recordProperty.ValueAsObject | productImageUrl"
    [class]="parentClass + ' productImage'"
    (click)="previewImage(recordProperty.ValueAsObject)"
  />
  <img
    *ngIf="
      recordProperty.ValueAsObject == null || recordProperty.ValueAsObject == ''
    "
    src="assets/not-available.jpg"
    [class]="parentClass + ' productImage'"
  />
</nz-form-control>

<ng-container *ngIf="recordProperty !== undefined && isMultiple">
  <div
    *ngFor="let value of values; let i = index"
    style="height: 310px"
    [hidden]="activeIndex != i"
  >
    <img
      style="width: 100%; max-height: 310px;height: auto;object-fit: cover;"
      [src]="value | productImageUrl"
      class="productImage"
      (click)="previewImage(recordProperty.ValueAsObject)"
    />
  </div>
  <div
    *ngFor="let value of values; let i = index"
    style="width: 64px; height: 64px; float: left; margin-right: 10px"
    (click)="activeIndex = i"
  >
    <img
      style="width: 64px; max-height: 64px;height: auto;object-fit: cover;"
      [src]="value | productImageUrl"
      class="productImage"
      (click)="previewImage(recordProperty.ValueAsObject)"
    />
  </div>
</ng-container>
